<template>
    <!-- 常に使われているコンポーネントではありませんが、主にキャンペーンで期間限定でLPにフロートバナーを表示するとき用に保存しています。 -->
    <a v-if="isEnabled && !isClosed" class="banner" :class="{ hidden: shouldBeHidden }" :href="href" target="_blank">
        <img :src="src" :alt="alt" />
        <button class="close" :class="closeBtnPosition" @click.prevent="close">
            <i class="el-icon-close" />
        </button>
    </a>
</template>

<script>
import { mapGetters } from 'vuex';
import { isBefore, isAfter } from '@/libs/date.js';

export default {
    props: {
        href: {
            type: String,
            required: true,
        },
        src: {
            type: String,
            required: true,
        },
        alt: {
            type: String,
            required: true,
        },
        closeBtnPosition: {
            type: String,
            default: 'right', // 'left' | 'right'
        },
    },
    data() {
        return {
            from: '2025-02-10',
            to: '2025-02-24',
            isClosed: false,
            shouldBeHidden: true,
            observer: undefined,
        };
    },
    computed: {
        ...mapGetters(['vw']),
        isSp() {
            return this.vw <= 640;
        },
        isEnabled() {
            const today = new Date();
            const start = this.from ?? 0;
            const end = this.to ?? Infinity;
            // 本番環境以外では確認のため期限前でも表示
            if (this.$config.appEnv !== 'production') return isBefore(today, end);

            return isAfter(today, start) && isBefore(today, end);
        },
    },
    mounted() {
        // SPのファーストビューには表示せず、下にスクロールしたら表示されるようにする。
        const title = document.getElementsByTagName('h1')[0];
        if (!title) return;
        this.observer = new IntersectionObserver(this.toggleVisibility, { threshold: 0.9 });
        this.observer.observe(title);
    },
    beforeDestroy() {
        this.observer?.disconnect();
    },
    methods: {
        close() {
            this.isClosed = true;
            this.observer?.disconnect();
            this.observer = undefined;
        },
        toggleVisibility(entries) {
            this.shouldBeHidden = this.isSp && entries[0].isIntersecting;
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/personal/main.scss';

.banner {
    display: block;
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 10;
    width: 50vw;
    max-width: 400px;
    background-color: #fff;
    border-radius: 7px;
    box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    line-height: 0;

    @include sp {
        width: 90vw;
        margin: 0 auto;
        left: 0;
        right: 0;
    }

    &:hover {
        opacity: 1;
    }

    img {
        transition: opacity 0.2s;
        &:hover {
            opacity: 0.8;
        }
    }

    .close {
        position: absolute;
        top: 3px;
        width: 26px;
        height: 26px;
        padding: 0;
        border-radius: 50%;
        border: none;
        overflow: hidden;
        display: grid;
        place-items: center;
        background-color: #fff;
        transition: filter 0.2s;

        &.right {
            right: 3px;
        }
        &.left {
            left: 3px;
        }

        &:hover {
            filter: invert(0.85);
        }

        i {
            font-size: 19px;
            font-weight: bold;
        }
    }

    &.hidden {
        opacity: 0;
        pointer-events: none;
    }
}
</style>
